// extracted by mini-css-extract-plugin
export default {"internal-server-error-page":"InternalServerErrorPage_internal-server-error-page__uzm9K"};